<template>
  <div class="filterItemOptionContainer nav-vertical__item flex-wrap py-0">
    <div class="nav-vertical__content">
      <input
        @input="onInput"
        class="mr-2 w-auto cursor-pointer filterItemCheckboxInput"
        :class="{ disabled: isDisabled }"
        type="checkbox"
        :checked="active"
        :disabled="isDisabled"
        :value="value"
        :id="text"
      />
      <label :for="text"> 
        {{ text }} 
        <span class="alignright">({{ count || 0 }}
          <div class="screenreader-only">results</div>)</span>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    active: Boolean,
    ariaLabel: String,
    disabled: Boolean,
    count: [Number, String],
    text: { required: true, type: String },
    title: { required: true, type: String },
    value: { required: true, type: [Number, String, Boolean] },
  },
  data: () => ({ on: false }),
  computed: {
    isDisabled() {
      if (this.active && !this.disabled) return false
      else return this.disabled || !this.count || Number(this.count) == 0
    },
  },
  methods: {
    onInput(e) {
      this.$emit('input', { active: e?.target?.checked, value: this.value })
    },
  },
}
</script>

<style lang="scss" scoped>
.filterItemOptionContainer,
.filterItemOptionContainer label {
  width: 100%;
}
.nav-vertical__item {
  padding-right: 0 !important;
}
.alignright {
  float: right;
}
.screenreader-only {
position:absolute;
left:-10000px;
top:auto;
width:1px;
height:1px;
overflow:hidden;
}
</style>
